module.exports = __webpack_public_path__ + "img/banner-kz.18087ca5.jpg";